import { render } from "./OrderPaymentMethod.vue?vue&type=template&id=e7abb02e&ts=true"
import script from "./OrderPaymentMethod.vue?vue&type=script&lang=ts"
export * from "./OrderPaymentMethod.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/diego/Projects/SL360/spylive360/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__